import request from '@/utils/http';
import { PFX, SRM } from '../../constant/constant.js';

// 管理端车辆信息
export const getManageVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/manageCars`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 工作台车辆信息
export const getWorkbenchVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/workbenchCars`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 批量启用车辆
export const enableVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/batchEnableRelation`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 批量停用车辆
export const disableVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/batchDisableRelation`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 删除车辆信息
export const deleteVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/batchDelete`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 获取登陆用户的供应商编码
export const getLoginUser = (params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/currentLoginUser/supplierInfo`,
        method: 'get',
        params: params
    });
};

// 根据车牌号查询车辆信息
export const checkVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/checkLicensePlateNo`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 新增车辆
export const addVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/addCar`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 新增车辆 不需审批
export const addVehiclePrivile = (params) => {
    return request({
        url: `${SRM}/supplierCarInfo/oldAddPrivilege`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 查询单个车辆
export const singleVehicle = (relationId, params = {}) => {
    return request({
        url: `${SRM}/supplierCarInfos/viewCar/` + relationId,
        method: 'get',
        params: params
    });
};

// 编辑车辆
export const editVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/updateCar`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 编辑车辆 不需审批
export const editVehiclePrivile = (params) => {
    return request({
        url: `${SRM}/supplierCarInfo/oldUpdatePrivilege`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 特权复制(数据回填)
export const copyVehicle = (relationId, params = {}) => {
    return request({
        url: `${SRM}/supplierCarInfos/getCarCopyInfo/` + relationId,
        method: 'get',
        params: params
    });
};

// 特权复制(提交)
export const submitCopyVehicle = (params) => {
    return request({
        url: `${SRM}/supplierCarInfos/specialCopy`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 导出车辆
export const exportVehicle = (params = {}) => {
    return request({
        url: `${SRM}/supplierCarInfos/exportCar`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'application/json' }
    });
};

// 管理端通过供应商编码获取当前供应商是否含有快递业务类型，控制商业保险字段必填与否
export const getBusinessType = (supplierCode, params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/manage/supplierInfo/` + supplierCode,
        method: 'get',
        params: params
    });
};

// 图片示例
export const getExample = (fileName) => {
    return request({
        url: `${SRM}/imageExample/view/${fileName}`,
        method: 'get',
        responseType: 'arraybuffer'
    });
};

// 撤回审批
export const revokeApprove = (relationId) => {
    return request({
        url: `${SRM}/supplierCarApproval/returnEvent/${relationId}`,
        method: 'put'
    });
};

// 审批详情信息（弹窗）
export const getVehicleApproveDetail = (relationId) => {
    return request({
        url: `${SRM}/supplierCarApproval/getApprovalDetail/${relationId}`,
        method: 'get'
    });
};

// 车辆审批页面详情
export const getVehicleApprovePage = (id) => {
    return request({
        url: `${SRM}/supplierCarApproval/getApprovalFormData/${id}`,
        method: 'get'
    });
};

// 通过车辆审批
export const passVehicleApprove = (params) => {
    return request({
        url: `${SRM}/supplierCarApproval/passApproval`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 驳回车辆审批
export const refuseVehicleApprove = (params) => {
    return request({
        url: `${SRM}/supplierCarApproval/refuseApproval`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 判断当前车辆是否有审批
export const existApprovalDetail = (relationId) => {
    return request({
        url: `${SRM}/supplierCarApproval/existApprovalDetail/${relationId}`,
        method: 'get'
    });
};

// 根据车牌号查询系统中是否存在该车辆信息
export const getSysLicensePlateNo = licensePlateNo => {
    return request({
        url: `${SRM}/supplierCarInfo/getSupplierCarInfoDetail/${licensePlateNo}`,
        method: 'get'
    });
};

// 车辆新增（新版）
export const addCarInfo = (params) => {
    return request({
        url: `${SRM}/supplierCarInfo/add`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 车辆编辑（新版）
export const editCarInfo = (params) => {
    return request({
        url: `${SRM}/supplierCarInfo/update`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 车辆新增（新版）不需审批
export const addCarInfoPrivilege = data => {
    return request({
        url: `${SRM}/supplierCarInfo/addPrivilege`,
        method: 'post',
        data
    });
};

// 车辆编辑（新版）不需审批
export const editCarInfoPrivilege = data => {
    return request({
        url: `${SRM}/supplierCarInfo/updatePrivilege`,
        method: 'post',
        data
    });
};

// 文件url获取ocr结果
export const getOcrInfoByUrl = data => {
    return request({
        url: `${SRM}/supplierAiInterfaceRecord/getOcrInfoByUrl`,
        method: 'post',
        data
    });
};

// 车辆信息详情
export const getSupplierCarInfoDetail = data => {
    return request({
        url: `${SRM}/supplierCarInfo/getSupplierCarInfoDetail/${data}`,
        method: 'get',
    });
};

// 合作/租赁协议 下载模板【车辆挂靠协议】
export const getSysControlParam = () => {
    return request({
        url: `${PFX}/backlog/getSysControlParamByCode`,
        method: 'get',
        params: { controlCode: 'affiliatedTemplateFileUrl' },
    })
}

// 车辆-装载方量提示
export const getSysControlParamByCode = (params) => {
    return request({
        url: `${PFX}/backlog/getSysControlParamByCode`,
        method: 'get',
        params,
    })
}

// 车辆-根据车型编码查车辆
export const getLengthByCode = (params) => {
    return request({
        url: `${PFX}/supplier/dcApi/cdTsEquipmentGroupSearch`,
        method: 'get',
        params,
    })
}


// 车辆复核通过
export const reviewPass = data => {
    return request({
        url: `${SRM}/supplierCarApprovalRecord/reviewPass`,
        method: 'post',
        data,
    })
}

// 车辆复核不通过
export const reviewReject = data => {
    return request({
        url: `${SRM}/supplierCarApprovalRecord/reviewReject`,
        method: 'post',
        data,
    })
}